import { Swiper, SwiperOptions, Navigation, Pagination, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);
const SWIPER_OPTIONS: SwiperOptions = {
  loop: true,
  autoHeight: false,
  slidesPerView: 1,
  noSwiping: true,
  noSwipingClass: '.swiper-slide',
  speed: 1000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  on: {
    init: function (swiper: any) {
      if ((swiper.params.loop && swiper.slides.length == 3) || (!swiper.params.loop && swiper.slides.length == 1)) {
        swiper.autoplay.stop();
      }
    },
  }
};
const sliderInit = (slider: HTMLElement) => new Swiper(slider, SWIPER_OPTIONS);
export default sliderInit;
